/**
 * VendorDocumentTypeService
 * Service for managing vendor document types
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor document type CRUD operations
 */
export class VendorDocumentTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorDocumentTypeService.DEFAULT_SERVICE_PATH,
            basePath: VendorDocumentTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
VendorDocumentTypeService.DEFAULT_SERVICE_PATH = 'vendors';
VendorDocumentTypeService.BASE_PATH = 'api/vendor-document-types';
//# sourceMappingURL=VendorDocumentTypeService.js.map